import { createContext } from 'react'

export const ApplicantProfileContext = createContext()
